<template>
    <el-container>
        <el-main>
            <el-row>
                <el-col>
                    <td-button type="primary" @click="addAreaNetwork" :permissions="permissions.addAreaNetwork">{{ $t('pgCommon.ADD_AREA_NETWORK') }}</td-button>
                </el-col>
            </el-row>
            <el-row id="table">
                <el-col>
                    <td-table
                        ref="tableMain"
                        :columns="columnsMain"
                        :dataSource="tableDataMain"
                        :hasLoading="tableMainLoading"
                        :hasPage="false"
                        :max-height="tableHeigth"
                        :hasMutiSelect="false"
                        @row-click="rowClick"
                    ></td-table>
                </el-col>
            </el-row>
        </el-main>
        <addAreaNetwork
            :title="title"
            v-if="dialogNetworkVisible"
            :dialogVisible="dialogNetworkVisible"
            :editData="editData"
            :isAdd="isAdd"
            :disabledSelectNetworkName="disabledSelectNetworkName"
            @dialogClose="dialogClose"
            @refreshData="queryNetworkAreaSettingList"
        ></addAreaNetwork>
    </el-container>
</template>

<script>
import addAreaNetwork from './assets/dialogAddAreaNetwork';
import api from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        addAreaNetwork
    },
    mounted() {
        this.initTableHeight();
        if (!this.queryCache) {
            this.queryNetworkAreaSettingList(); // 进行页面初始化数据的加载
        }
    },
    data() {
        return {
            queryCache: false,
            permissions: {
                addAreaNetwork: ['areaNetworkSetting:addAreaNetwork'],
                editAreaNetwork: ['areaNetworkSetting:editAreaNetwork'],
                deleteAreaNetwork: ['areaNetworkSetting:deleteAreaNetwork']
            },
            title: '',
            dialogNetworkVisible: false,
            dialogNetworkServiceVisible: false,
            sExtendInfo: {},
            tableDataMain: [],
            row: '',
            editData: '',
            isAdd: true,
            disabledSelectNetworkName: false,
            tableMainLoading: false,
            //tableBranchLoading: false,
            deleteNetworkBtnLoading: false,
            tableHeigth: '',
            columnsMain: [
                {
                    label: 'pgCommon.NETWORK_NAME',
                    prop: 'sName',
                    showOverflowTooltip: true
                },
                {
                    label: 'pgCommon.Network_IP',
                    prop: 'sAddress',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.OPERATE',
                    align: 'center',
                    tableWidth: '200',
                    render: (createElement, params) => {
                        let result = [];
                        let editAreaNetworkBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissions.deleteAreaNetwork },
                                on: {
                                    click: () => {
                                        this.editAreaNetworkBtn(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let deleteAreaNetworkBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissions.editAreaNetwork },
                                on: {
                                    click: () => {
                                        //this.deleteBtn(params.row);
                                        this.deleteAreaNetworkBtn(params.row);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        result.push(editAreaNetworkBtn);
                        //屏蔽 “总控中间件网络行”的 删除按钮
                        if (params.row.sId != 'd7098878c0044bbdb3a1475ae98c9a5c') {
                            result.push(deleteAreaNetworkBtn);
                        }
                        return createElement('div', result);
                    }
                }
            ]
        };
    },

    activated() {
        if (this.queryCache) {
            this.queryNetworkAreaSettingList();
        }
        this.queryCache = true;
    },

    methods: {
        /**添加网络配置按钮触发方法 */
        addAreaNetwork() {
            this.title = this.$t('pgCommon.ADD_AREA_NETWORK');
            this.isAdd = true;
            this.disabledSelectNetworkName = false;
            this.dialogNetworkVisible = true;
        },
        /**编辑网络配置按钮触发方法 */
        editAreaNetworkBtn(row) {
            if (row == '') {
                this.$message({ showClose: true, message: this.$t('pgError.ERROR_UPDATE_NETWORK'), type: 'warning' });
                return;
            }
            this.title = this.$t('pgCommon.EDIT_NETWORK_AREA');
            this.isAdd = false;
            this.disabledSelectNetworkName = true;
            this.dialogNetworkVisible = true;
            this.editData = row;
        },
        /**删除网络配置按钮触发方法 */
        deleteAreaNetworkBtn(row) {
            if (row == '') {
                this.$message({ showClose: true, message: this.$t('pgError.ERROR_DELETE_NETWORK'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteNetworkSettings(row);
                })
                .catch(() => {});
        },
        /**删除网络设置 */
        deleteNetworkSettings(row) {
            let params = { sId: row.sId };
            this.deleteNetworkBtnLoading = true;
            api.delNetworkAreaWhiteBlack(params, response => {
                this.deleteNetworkBtnLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkAreaSetting/delNetworkAreaWhiteBlack', response);
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                row = '';
                this.queryNetworkAreaSettingList();
            });
        },
        /**关闭dialog触发的方法 */
        dialogClose() {
            this.dialogNetworkVisible = false;
            this.dialogNetworkServiceVisible = false;
            this.sExtendInfo = {};
            this.queryNetworkAreaSettingList();
        },
        /**网络列表点击行信息触发 */
        rowClick(row) {
            this.row = this.$util.clone(row);
        },
        /**加载table高度 */
        initTableHeight() {
            let table = document.getElementById('table');
            this.tableHeigth = document.documentElement.clientHeight - table.offsetTop - 40;
        },
        /**获取所有局域网络信息（主表格数据） */
        queryNetworkAreaSettingList() {
            this.tableMainLoading = true;
            api.queryNetworkAreaSettingList(null, response => {
                this.tableMainLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkSetting/queryNetworkAreaSettingList', response);
                    return;
                }
                this.tableDataMain = response.data.content;
            });
        }
    }
};
</script>

<style></style>
